import { Component, OnInit, AfterViewInit, OnChanges, Input, ChangeDetectionStrategy } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

import { AppComponent } from '../../app.component'

@Component({
    selector: 'rebar-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit, OnChanges {

  constructor(
    private authService: MsalService,
    private app: AppComponent
  ) { }
  username: any = ''
  health=true;
  headerText: string;
  defaultimg:boolean=true
  hwmainnewimg:boolean=false;

  @Input() UserData: string;
  ngOnInit() {
    this.username = this.authService.instance.getAllAccounts()[0]?.name ?? '';
    this.headerText = "Natural Language Processing Platform"
  }

  ngAfterViewInit() { }

  new_showComponent(ncomp:any){
    if(ncomp == "hwmain")
    {
      this.hwmainnewimg = true;
      this.defaultimg = false;
    this.app.ShowDiv(ncomp);  
    this.health=false;
    this.headerText = "Prototype (This prototype will be shortly moved to https://Well-being.accenture.com)"
    }
    if(ncomp == "hwmainnew")
    {
    this.app.ShowDiv(ncomp);  
    this.health=false;
    this.hwmainnewimg = true;
    this.defaultimg = false;
    this.headerText = "One stop solution for all well-being related reporting, analytics and insights"
    }
    else
    {
      this.headerText = "Natural Language Processing Platform"
      //this.hwmainnewimg = false;
      //this.defaultimg = true;
      //this.health=false
      this.app.ShowDiv(ncomp);  
    }
    
   
    
  }
  


  ngOnChanges() {
    
    if (this.UserData != "") {
      this.username = this.authService.instance.getAllAccounts()[0]?.name ?? '';
      
        
    }
}

}
